import React from "react"

export const PageTitle = ({title}) => (
    <header className="wrap-title">
        <div className="container">
            <h1 className="page-title">{title}</h1>
        </div>
    </header>

);